<div class="General">
  <h3>{{'DataSales.PriceList'|translate}}</h3>
      <div class="row">
          <div class="col-md">
            <ul>
              <li>
                <strong>{{'DataSales.LosAngeleseCounty'|translate}}</strong><br>
                {{'DataSales.Shapefile'|translate}}<br>
                DVD: $17.00<br>
                ({{'DataSales.updatedaroundthebeginning'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.ApartmentHouseListing'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Updatedfiscalyear'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.CrossRefRoll'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Updatedfiscalyear'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.SecuredLocalRoll'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Updatedfiscalyear'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.LAwallmap'|translate}}</strong><br>
                $60.00<br>
              </li>
              <br>
              <li>
                <strong>{{'DataSales.ParcelandIndex'|translate}}</strong><br>
                {{'DataSales.DVDfull'|translate}}: $185.00<br>
                {{'DataSales.DVDmonthly'|translate}}: $15.00<br>
                ({{'DataSales.updatedatleastweekly'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.ParcelChange'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Annually'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.ParcelChangeCity'|translate}}</strong><br>
                DVD: $50.00 ({{'DataSales.Percity'|translate}})<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Percity'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.ParcelChangeEntireLA'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
              </li>
              <br>
            </ul>
          </div>
          <div class="col-md">
            <ul>
              <li>
                <strong>{{'DataSales.PubliclyOwnedParcels'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Updatedfiscalyear'|translate}})({{'DataSales.TextFormat'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.SalesList'|translate}}</strong><br>
                DVD: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.UpdatedQuarterly'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.SecuredBasicFile1'|translate}}</strong><br>
                DVD: $50.00 ({{'DataSales.NoMinimum'|translate}})<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>

                {{'DataSales.EntireCounty'|translate}}
              </li>
              <br>
              <li>
                <strong>{{'DataSales.SpecialTransfer'|translate}}</strong><br>
                DVD: $50.00 <br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
              </li>
              <br>
              <li>
                <strong>{{'DataSales.TRAagencyListing'|translate}}</strong><br>
                DVD: $17.00 <br>
                {{'DataSales.ElectronicFormat'|translate}}: $17.00<br>
                ({{'DataSales.Updatedfiscalyear'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.UnsecuredRoll'|translate}}</strong><br>
                DVD: $50.00 <br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>
                ({{'DataSales.Updatedfiscalyear'|translate}})
              </li>
              <br>
              <li>
                <strong>{{'DataSales.PersonalPropertyAbstracts'|translate}}</strong><br>
                ({{'DataSales.Updatedfiscalyear'|translate}})<br><br>
                {{'DataSales.AircraftDVD'|translate}}: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br><br>
                {{'DataSales.BusinessDVD'|translate}}: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br><br>
                {{'DataSales.MarineDVD'|translate}}: $50.00<br>
                {{'DataSales.ElectronicFormat'|translate}}: $50.00<br>

              </li>
              <br>
            </ul>
          </div>
      </div>
      <h4>{{'DataSales.Labelsmailingadd'|translate}}</h4>
      <p>{{'DataSales.Setupfee'|translate}} = $58.00. {{'DataSales.Processingoptions'|translate}}</p>
      <ul>
        <li><strong>{{'DataSales.Option1'|translate}}</strong>: $33.00 ({{'DataSales.Electronicinput1'|translate}}) | <strong>{{'DataSales.Total'|translate}}</strong> ({{'DataSales.inclsetup'|translate}}): $91.00</li>
        <li><strong>{{'DataSales.Option2'|translate}}</strong>: $33.00 ({{'DataSales.Electronicinput2'|translate}}) | <strong>{{'DataSales.Total'|translate}}</strong> ({{'DataSales.inclsetup'|translate}}): $91.00</li>
      </ul>
      <p>{{'DataSales.Additionaladdresslabels'|translate}}: $8.00</p>
      <p>{{'DataSales.Mailinglistslabels'|translate}}</p>
      <p><strong>{{'DataSales.Mailorders'|translate}}</strong></p>
      <p>{{'DataSales.Fordetails'|translate}}</p>
      <strong>LOS ANGELES COUNTY ASSESSOR</strong><br>
      c/o Property Data Sales<br>
      500 West Temple Street, Room 291<br>
      Los Angeles, CA 90012<br>
      <strong>(213) 974-3363</strong><br><br>
      <p>{{'DataSales.Pricescurrent'|translate}}</p>
      <p>{{'DataSales.Allcharges'|translate}}</p><br>

</div>

